import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import enTranslations from '../locales/en.json'
import faTranslations from '../locales/fa.json'

i18n.use(initReactI18next).init({
  resources: {
    en: {
      translation: enTranslations,
    },
    fa: {
      translation: faTranslations,
    },
  },
  lng: 'fa', // default language
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false, // React already escapes values
  },
  react: {
    useSuspense: false,
  },
})

export default i18n
